import { render, staticRenderFns } from "./OptionsList.vue?vue&type=template&id=136ad3c8&scoped=true&"
import script from "./OptionsList.vue?vue&type=script&lang=js&"
export * from "./OptionsList.vue?vue&type=script&lang=js&"
import style0 from "./OptionsList.vue?vue&type=style&index=0&id=136ad3c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../abbreviation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136ad3c8",
  null
  
)

export default component.exports